import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoUser } from 'app/shared/models/security/dto-user.model';
import { ISelect } from 'app/shared/models/select.model';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { IDtoEmployeeFilter } from 'app/shared/models/request/holiday/dto-employee-filter.model';
import { HolidayService } from 'app/views/appviews/request/holiday.service';
import { CustomerService } from 'app/views/appviews/quote/customer.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';

@Component({
    selector: 'app-modal-user',
    templateUrl: './modal-user.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalUserComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formUser: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Retorno a pantalla padre */
    public onClose: Subject<boolean>;
    /**Variables */
    private action: string;
    private user: IDtoUser;
    /**Catalogos */
    private catalogZones: Observable<ISelect[]>;
    private catalogCustomers: Observable<IDtoCatalog[]>;
    private catalogEmployees: Observable<ISelect[]>;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private identityService: IdentityService
        , private configGeneral: AppConfig
        , private recruitmentService: RecruitmentService
        , private holidayService: HolidayService
        , private customerService: CustomerService) {
        this.initializeFormUser();
    }
    ngOnInit(): void {
        this.catalogZones = this.recruitmentService.getCatalogZones();
        this.catalogCustomers = this.customerService.getCatalogCustomers();
        this.getCatalogEmployeesByFilter();
        this.onClose = new Subject();
        if (this.action === 'edit') {
            this.formUser.patchValue(this.user);
            this.formUser.get('zonesId').setValue(this.patchZones(this.user.zonesId));
            this.formUser.get('clientIds').setValue(this.user.clientIds);
        }
    }
    private initializeFormUser() {
        this.formUser = this.formBuilder.group({
            email: [null, [Validators.required, Validators.email, Validators.maxLength(255)]],
            username: [null, [Validators.required, Validators.maxLength(256)]],
            zonesId: [null],
            clientIds: [null],
            employeeId: [null]
        });
    }
    private getCatalogEmployeesByFilter(): void {
        const list = {} as IDtoEmployeeFilter;
        this.catalogEmployees = this.holidayService.getCatalogEmployeesByFilter(list);
    }
    private submit(): void {
        if (this.formUser.valid) {
            if (this.action === 'add') {
                this.save();
            } else {
                this.update();
            }
        } else {
            this.snotifyService.error('Capture toda la información requerida para poder continuar'
                , 'Validación', this.configToast);
        }
    }
    private save(): void {
        const data = this.formUser.value as IDtoUser;
        data.password = '@Terminal1';
        this.identityService.addUser(data)
            .subscribe(
                (x) => {
                    if (x.isCorrect === true) {
                        this.onClose.next(true);
                        this.onCancel();
                    } else {
                        this.onClose.next(false);
                        this.onCancel();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private update(): void {
        const data = this.formUser.value;
        this.user.username = data.username;
        this.user.email = data.email;
        this.user.zonesId = data.zonesId;
        this.user.clientIds = data.clientIds;
        this.user.employeeId = data.employeeId;
        this.identityService.updateUser(this.user)
            .subscribe(
                (x) => {
                    if (x.isCorrect === true) {
                        this.onClose.next(true);
                        this.onCancel();
                    } else {
                        this.onClose.next(false);
                        this.onCancel();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private patchZones(zones: number[]): string[] {
        const data = [];
        zones.forEach(element => {
            data.push(element.toString());
        });
        return data;
    }
}
